import { css } from "styled-components";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
const universalMusicStyles = {
    Inputs: ()=>css`
		> * {
			${({ theme  })=>theme.media.phone.only} {
				&:first-child {
					input {
						border: 1px solid ${({ theme  })=>theme.colors.grays.light};
						${BorderRadius({
            topLeft: '4px',
            bottomLeft: '4px'
        })}
						border-right: unset;
					}
				}

				&:last-child {
					input {
						border: 1px solid ${({ theme  })=>theme.colors.grays.light};
						${BorderRadius({
            topRight: '4px',
            bottomRight: '4px'
        })}
					}
				}
			}
		}
	`
};
export default universalMusicStyles;

//# sourceMappingURL=universalMusic.js.map